'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _TextArea = require('../../components/TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _PrimaryContainer = require('./components/PrimaryContainer');

var _PrimaryContainer2 = _interopRequireDefault(_PrimaryContainer);

var _PrimaryDescription = require('./components/PrimaryDescription');

var _PrimaryDescription2 = _interopRequireDefault(_PrimaryDescription);

var _SecondaryDescription = require('./components/SecondaryDescription');

var _SecondaryDescription2 = _interopRequireDefault(_SecondaryDescription);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubHubDescription = function SubHubDescription(_ref) {
  var title = _ref.title,
      _ref$primaryDescripti = _ref.primaryDescription,
      primaryDescription = _ref$primaryDescripti === undefined ? '' : _ref$primaryDescripti,
      _ref$secondaryDescrip = _ref.secondaryDescription,
      secondaryDescription = _ref$secondaryDescrip === undefined ? '' : _ref$secondaryDescrip,
      _ref$image = _ref.image,
      image = _ref$image === undefined ? '' : _ref$image,
      _ref$imageAlt = _ref.imageAlt,
      imageAlt = _ref$imageAlt === undefined ? '' : _ref$imageAlt,
      _ref$hasTopMargin = _ref.hasTopMargin,
      hasTopMargin = _ref$hasTopMargin === undefined ? false : _ref$hasTopMargin,
      _ref$hasBottomMargin = _ref.hasBottomMargin,
      hasBottomMargin = _ref$hasBottomMargin === undefined ? false : _ref$hasBottomMargin;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $hasTopMargin: hasTopMargin,
      $hasBottomMargin: hasBottomMargin
    },
    _react2.default.createElement(
      _Title2.default,
      null,
      _react2.default.createElement(_YellowLineSVG2.default, null),
      _react2.default.createElement(
        'h2',
        null,
        title
      )
    ),
    _react2.default.createElement(
      _PrimaryContainer2.default,
      null,
      image && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', {
          src: image,
          alt: imageAlt
        })
      ),
      primaryDescription && _react2.default.createElement(
        _PrimaryDescription2.default,
        null,
        _react2.default.createElement(_TextArea2.default, {
          htmlString: primaryDescription
        })
      )
    ),
    secondaryDescription && _react2.default.createElement(
      _SecondaryDescription2.default,
      null,
      _react2.default.createElement(_TextArea2.default, {
        htmlString: secondaryDescription
      })
    )
  );
};

SubHubDescription.propTypes = {
  title: _propTypes2.default.string.isRequired,
  primaryDescription: _propTypes2.default.string,
  secondaryDescription: _propTypes2.default.string,
  image: _propTypes2.default.string,
  imageAlt: _propTypes2.default.string,
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool
};

SubHubDescription.displayName = 'SubHubDescription';

exports.default = SubHubDescription;
SubHubDescription.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'SubHubDescription',
  'props': {
    'primaryDescription': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'secondaryDescription': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'image': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'imageAlt': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
};